<div class="comp-menu">
	<div
		class="d-flex flex-nowrap justify-content-between align-items-center gap-3 py-3"
	>
		<p>{{ "choose_test" | langVal }}</p>
		@if (permsService?.perms?.administrative) {
			<button
				class="btn btn-icon"
				(click)="modalProps = { name: 'update-test' }"
				titleLang="add"
				icon="plus"
			></button>
		}
	</div>

	<div class="items">
		@for (test of tests; track test) {
			<div class="tests-autotext-menu-list d-flex align-items-center gap-3">
				<!-- <div style="padding-inline-end: 8px; margin-top: 2px"> -->
				<div>
					<input
						type="checkbox"
						[checked]="test.checked"
						(change)="onCheck(test, $event.target.checked)"
					/>
				</div>
				<div
					(click)="openTestAnswersModal(test.id)"
					class="colstat-small-triple"
				>
					{{ test.name }}
				</div>
				@if (permsService?.perms?.administrative && test.public === "no") {
					<div class="text-end colstat-small">
						<app-icon
							icon="settings1"
							(click)="openUpdateTest(test); $event.stopImmediatePropagation()"
						/>
					</div>
				}
			</div>
		}
	</div>
	<div class="modal-btns">
		@if (anyChecked) {
			<button
				class="btn btn-primary"
				(click)="modalProps = { name: 'invite-contactways' }"
				[spinner]="isSendingInvite"
			>
				{{ "send_invite" | langVal }}
			</button>
			<!--      <button class="btn btn-primary">{{"add_to_group" |langVal}}</button>-->
		}
	</div>
</div>

@switch (modalProps?.name) {
	@case ("update-test") {
		<app-modal-wrap
			(onClose)="modalProps = null; getTests()"
			title="test"
			modalWrapperClass="modal-750"
		>
			<app-update-test
				(onClose)="modalProps = null; getTests()"
				[test]="modalProps.test"
			/>
		</app-modal-wrap>
	}
	@case ("testanswers-fill") {
		<app-modal-wrap
			(onClose)="modalProps = null"
			title="testanswers_fill"
			modalWrapperClass="modal-650"
		>
			<app-testanswers-fill
				(onClose)="modalProps = null; closeIfValue($event)"
				isModalMode
				[test_id]="modalProps.test_id"
				[patient_id]="patient_id"
				[in_followup]="in_followup"
			/>
		</app-modal-wrap>
	}
	@case ("invite-contactways") {
		<app-modal-wrap
			(onClose)="modalProps = null"
			title="contactways"
			modalWrapperClass="modal-800"
		>
			<app-gen-table-display
				(onClose)="modalProps = null; $event?.length && sendInvite($event)"
				tableName="contactways"
				filterField="patient_id"
				[filterFieldValue]="patient_id"
				fieldNameInItemToDisplay="contactway"
				chooseOnlyOne
				[filterFieldOrs]="{ contactway_identifier: ['email', 'phone'] }"
			/>
		</app-modal-wrap>
	}
}
